import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  MenuItem,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  forwardRef,
  useContext,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { AppContext } from "../../lib/Context";
import { createLeadProposalValidation } from "../../utils/Validation";
import {
  createLeadProposal,
  updateLeadAndResendProposal,
} from "../../services/LeadProposalApi";
import { getAllProducts } from "../../services/ProductApi";
import { getAllAgents } from "../../services/AgentApi";
import { handleApiCall, handleOpenSnackBar } from "../../utils/helper";
import { baseUrl } from "../../services";
import AppLoader from "../loader";
import Label from "../label";
import CustomDropDown from "../select";
import TextInput from "../textInput";
import axios from "axios";
import CancelIcon from "../../assets/icons/cross-bold-icon.png";
import GlobalButton from "../button";
import CustomCheckBox from "../checkbox";
import CustomDateTimePicker from "../dateTimePicker";
import { getAccessToken } from "../../services/tokenStore";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiPaper-root": {
    width: "600px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

let paramsData = {};

const currentProvider = [
  "New Installation",
  "BT Group",
  "Vodafone UK",
  "Sky UK",
  "TalkTalk Business",
  "Virgin Media Business",
  "Daisy Group",
  "Gamma Telecom",
  "Zen Internet",
  "KCOM Group",
  "Hyperoptic",
  "Plusnet Business",
  "XLN Telecom",
  "Utility Warehouse",
  "Community Fibre",
  "bOnline",
  "Cuckoo",
  "YouFibre",
  "CityFibre",
  "Giganet",
  "Swish Fibre",
  "Clear Business",
  "4Comm",
  "Uniplus",
  "Trust Telecom",
  "Onecom",
];

const AddEditLeadProposalDialog = forwardRef(({}, ref) => {
  const imageInputRef = useRef();
  const pdfInputRef = useRef();
  const { palette } = useTheme();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [enableThirdParty, setEnableThirdParty] = useState(false);
  const [images, setImages] = useState([]);
  const [attachment, setAttachment] = useState(null);
  const [allAgents, setAllAgents] = useState([]);
  const { userData } = useContext(AppContext);
  const [inputValue, setInputValue] = useState({
    username: "",
    businessName: "",
    contact: "",
    address: "",
    email: "",
    contractEndDate: null,
    followUpDate: null,
    currentProvider: "",
    note: "",
    productType: "",
    receiverEmail: "",
    agent: "",
    dateTime: null,
    // meeterName: "",
  });

  const [inputError, setInputError] = useState({
    username: false,
    businessName: false,
    productType: false,
    isValidEmail: false,
    followUpDate: false,
    receiverEmail: false,
    isValidReceiverEmail: false,
    agent: false,
    dateTime: false,
    // meeterName: false,
  });

  const isAdmin = userData?.designation === "Admin" ? true : false;


  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
      fetchAllProducts();
      if (isAdmin) {
        handleFetchAllGents();
      }
      if (params.type === "edit") {
        setAttachment(params?.data?.attachment);
        setImages(params?.data?.images || []);
        setEnableThirdParty(params?.data?.receiverEmail ? true : false);
        setInputValue({
          ...inputValue,
          productType: params?.data?.productType?._id || "",
          username: params?.data?.username,
          businessName: params?.data?.businessName || "",
          contact: params?.data?.contact || "",
          address: params?.data?.address || "",
          email: params?.data?.email,
          contractEndDate: dayjs(params?.data?.contractEndDate),
          followUpDate: dayjs(params?.data?.followUpDate),
          currentProvider: params?.data?.currentProvider,
          note: params?.data?.note,
          // meeterName: params?.data?.meeterName || "",
          receiverEmail: params?.data?.receiverEmail || "",
          agent: params?.data?.agentId?._id || "",
          dateTime: params?.data?.setMeeting
            ? dayjs(params?.data?.setMeeting)
            : null,
        });
      }
    },
    disable() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setInputValue({});
    setInputError({});
    setImages([]);
    setEnableThirdParty(false);
    setAttachment(null);
  };

  const handleChangeValue = (event) => {
    const { name, value } = event.target;
    setInputError((preError) => ({
      ...preError,
      [name]: false,
      isValidEmail: name === "email" ? false : inputError.isValidEmail,
      isValidReceiverEmail:
        name === "receiverEmail" ? false : inputError.isValidReceiverEmail,
    }));
    setInputValue((preValue) => ({ ...preValue, [name]: value }));
  };

  const handleDateChange = (value, name) => {
    setInputError((preError) => ({
      ...preError,
      [name]: false,
    }));
    setInputValue((preValue) => ({ ...preValue, [name]: value }));
  };

  const handleAddLeadProposal = () => {
    const validate = createLeadProposalValidation(
      inputValue,
      setInputError,
      enableThirdParty,
      allProducts,
    );
    if (validate) {
      return;
    }

    if (!inputValue.agent && isAdmin) {
      return setInputError((preError) => ({
        ...preError,
        agent: true,
      }));
    }

    // Check if selected product is CPS
    const selectedProduct = allProducts.find(
      (product) => product._id === inputValue.productType,
    );
    const isCPS = selectedProduct && selectedProduct.name === "CPS";

    let payload = {
      agentId: isAdmin ? inputValue.agent : userData?._id,
      username: inputValue.username,
      businessName: inputValue.businessName,
      contact: inputValue.contact,
      address: inputValue.address,
      email: inputValue.email,
      currentProvider: inputValue.currentProvider,
      note: inputValue.note,
      agentNumber: userData?.contact,
      agentName: userData?.username,
      productType: inputValue.productType,
      images: images,
      attachment: attachment || "",
      meeterName: "Jake",
      ...(inputValue.dateTime && {
        setMeeting: new Date(inputValue.dateTime.$d),
      }),

      ...(enableThirdParty && {
        receiverEmail: inputValue.receiverEmail,
      }),

      // Only include contractEndDate and followUpDate if not CPS
      ...(!isCPS && {
        contractEndDate: new Date(inputValue.contractEndDate?.$d) || null,
        followUpDate: new Date(inputValue.followUpDate.$d),
      }),

      ...(isCPS &&
        paramsData?.type === "add" && {
          leadStage: "pending",
        }),
    };

    if (paramsData?.type === "add") {
      handleApiCall(
        "",
        createLeadProposal,
        payload,
        setIsLoading,
        handleClose,
        paramsData.getData,
      );
    } else {
      handleApiCall(
        paramsData?.data?._id,
        updateLeadAndResendProposal,
        payload,
        setIsLoading,
        handleClose,
        paramsData.getData,
      );
    }
  };

  const fetchAllProducts = async () => {
    try {
      const response = await getAllProducts({ status: true });
      if (response?.data.status === "success") {
        let data = response?.data.data;
        setAllProducts(data);
      }
    } catch (error) {
      console.error(error, "ERROR");
    }
  };

  const handleFetchAllGents = async () => {
    try {
      const response = await getAllAgents();
      if (response?.data.status === "success") {
        let data = response.data.data;
        setAllAgents(data);
      }
    } catch (error) {
      console.error("error", error?.message);
    }
  };

  const useStyle = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px",
      "& .MuiOutlinedInput-input": {
        padding: "12px 16px",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${palette.text.coolGrey}`,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${palette.text.coolGrey} !important`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${palette.text.coolGrey} !important`,
      },
    },
    "& .Mui-error": {
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #d32f2f !important`,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #d32f2f !important`,
      },
    },
    "& .MuiFormHelperText-root": {
      marginLeft: 0,
      marginTop: 0,
    },
    "& .Mui-disabled": {
      cursor: "not-allowed",
    },
  };

  const handleUploadImages = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

    if (!allowedTypes.includes(file.type)) {
      handleOpenSnackBar("error", "Only image files are allowed.");
      imageInputRef.current.value = null;
      return;
    }

    const token = getAccessToken();

    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("file", file);
      const response = await axios({
        method: "post",
        url: `${baseUrl}upload/image`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (response.data.status === "success") {
        setImages((prev) => [...prev, response.data?.url]);
        handleOpenSnackBar("success", response?.data?.message);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      imageInputRef.current.value = null;
      setIsLoading(false);
    }
  };

  const handleUploadPdf = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["application/pdf"];

    if (!allowedTypes.includes(file.type)) {
      handleOpenSnackBar("error", "Only PDF files are allowed.");
      pdfInputRef.current.value = null;
      return;
    }

    const token = getAccessToken();

    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("file", file);
      const response = await axios({
        method: "post",
        url: `${baseUrl}upload/pdf`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          ...(token && {
            Authorization: `Bearer ${token}`,
          }),
        },
      });

      if (response.data.status === "success") {
        setAttachment(response.data?.url);
        handleOpenSnackBar("success", response?.data?.message);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      pdfInputRef.current.value = null;
      setIsLoading(false);
    }
    // handle other file upload logic
  };

  const handleRemoveImage = (index) => {
    setImages((prev) => {
      const newAttachments = [...prev];
      newAttachments.splice(index, 1);
      return newAttachments;
    });
  };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AppLoader isVisible={isLoading} />
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <Stack
            p={2}
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography
              variant="h1"
              fontSize={"1.5rem"}
              fontWeight={500}
              color={"secondary.dark"}
            >
              {`${paramsData?.type === "add" ? "Add" : "Edit"} Lead Proposal`}
            </Typography>
            <IconButton onClick={handleClose}>
              <img src={CancelIcon} alt="cancel-icon" width={25} />
            </IconButton>
          </Stack>
          <DialogContent dividers>
            <Box component={"form"} maxWidth={500} margin={"auto"}>
              <Grid container spacing={2}>
                {isAdmin && (
                  <Grid item xs={12}>
                    <Label title={"Select Agent"} htmlFor={"select-agent"} />
                    <CustomDropDown
                      id={"select-agent"}
                      required
                      value={inputValue.agent}
                      name={"agent"}
                      onChange={handleChangeValue}
                      stylePropos={useStyle}
                      inputError={inputError.agent}
                      helperText={inputError.agent && "Agent is required"}
                    >
                      <MenuItem value={""}>None</MenuItem>
                      {allAgents.map((val, ind) => {
                        return (
                          <MenuItem key={ind} value={val._id}>
                            {val.username}
                          </MenuItem>
                        );
                      })}
                    </CustomDropDown>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Label title={"Products type"} htmlFor={"product-type"} />
                  <CustomDropDown
                    id={"product-type"}
                    required
                    value={inputValue.productType}
                    name={"productType"}
                    onChange={handleChangeValue}
                    stylePropos={useStyle}
                    inputError={inputError.productType}
                    helperText={
                      inputError.productType && "Product type is required"
                    }
                  >
                    <MenuItem value={""}>None</MenuItem>
                    {allProducts.map((val, ind) => {
                      return (
                        <MenuItem key={ind} value={val._id}>
                          {val.name}
                        </MenuItem>
                      );
                    })}
                  </CustomDropDown>
                </Grid>
                <Grid item xs={12}>
                  <Label
                    title={"Customer Name"}
                    required
                    htmlFor={"customer-name"}
                  />
                  <TextInput
                    id={"customer-name"}
                    type={"text"}
                    required
                    error={inputError.username}
                    helperText={
                      inputError.username && "Customer name is required"
                    }
                    defaultStyle={true}
                    placeholder={"Enter customer name"}
                    value={inputValue.username}
                    name={"username"}
                    onChange={handleChangeValue}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Label
                    title={"Customer Business Name"}
                    required
                    htmlFor={"business-name"}
                  />
                  <TextInput
                    id={"business-name"}
                    type={"text"}
                    required
                    error={inputError.businessName}
                    helperText={
                      inputError.businessName &&
                      "Customer Business name is required"
                    }
                    defaultStyle={true}
                    placeholder={"Enter customer business name"}
                    value={inputValue.businessName}
                    name={"businessName"}
                    onChange={handleChangeValue}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Label
                    title={"Customer Contact"}
                    required
                    htmlFor={"customer-contact"}
                  />
                  <TextInput
                    id={"customer-contact"}
                    type={"number"}
                    required
                    error={inputError.contact}
                    helperText={
                      inputError.contact && "Customer contact is required"
                    }
                    defaultStyle={true}
                    placeholder={"Enter customer contact"}
                    value={inputValue.contact}
                    name={"contact"}
                    onChange={handleChangeValue}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Label
                    title={"Customer Address"}
                    required
                    htmlFor={"customer-address"}
                  />
                  <TextInput
                    id={"customer-address"}
                    type={"text"}
                    required
                    error={inputError.address}
                    helperText={
                      inputError.address && "Customer address is required"
                    }
                    defaultStyle={true}
                    placeholder={"Enter customer address"}
                    value={inputValue.address}
                    name={"address"}
                    onChange={handleChangeValue}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Label
                    title={"Customer Email"}
                    required
                    htmlFor={"user-email"}
                  />
                  <TextInput
                    id={"user-email"}
                    type={"email"}
                    required
                    error={inputError.email || inputError.isValidEmail}
                    helperText={
                      inputError.email
                        ? "Email is required"
                        : inputError.isValidEmail
                          ? "Invalid email format"
                          : null
                    }
                    defaultStyle={true}
                    placeholder={"Enter customer email"}
                    value={inputValue.email}
                    name={"email"}
                    onChange={handleChangeValue}
                  />
                </Grid>

                {(() => {
                  const selectedProduct = allProducts.find(
                    (product) => product._id === inputValue.productType,
                  );
                  const isCPS =
                    selectedProduct && selectedProduct.name === "CPS";

                  if (isCPS) {
                    return null; // Don't show contract end date and follow up date for CPS
                  }

                  return (
                    <>
                      <Grid item xs={12}>
                        <Label
                          title={"Contract End Date"}
                          required
                          htmlFor={"contract-end-date"}
                        />
                        <DatePicker
                          format="DD.MM.YY"
                          value={inputValue.contractEndDate}
                          sx={useStyle}
                          slotProps={{
                            textField: {
                              error: inputError.contractEndDate,
                              helperText:
                                inputError.contractEndDate &&
                                "Contract end date is required",
                            },
                          }}
                          onChange={(val) =>
                            handleDateChange(val, "contractEndDate")
                          }
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Label
                          title={"Follow Up Date"}
                          required
                          htmlFor={"follow-up-date"}
                        />
                        <DatePicker
                          format="DD.MM.YY"
                          value={inputValue.followUpDate}
                          sx={useStyle}
                          disablePast
                          slotProps={{
                            textField: {
                              error: inputError.followUpDate,
                              helperText:
                                inputError.followUpDate &&
                                "Follow up date is required",
                            },
                          }}
                          onChange={(val) =>
                            handleDateChange(val, "followUpDate")
                          }
                        />
                      </Grid>
                    </>
                  );
                })()}

                {(() => {
                  const selectedProduct = allProducts.find(
                    (product) => product._id === inputValue.productType,
                  );
                  if (selectedProduct && selectedProduct.name === "CPS") {
                    return (
                      <>
                        {/* <Grid item xs={12}>
                          <Label
                            title={"Attendee Name"}
                            required
                            htmlFor={"meeter-name"}
                          />
                          <TextInput
                            id={"meeter-name"}
                            type={"text"}
                            // required
                            error={inputError.meeterName}
                            helperText={
                              inputError.meeterName &&
                              "Attendee name is required"
                            }
                            defaultStyle={true}
                            placeholder={"Enter Attendee name"}
                            value={inputValue.meeterName}
                            name={"meeterName"}
                            onChange={handleChangeValue}
                          />
                        </Grid> */}
                        <Grid item xs={12}>
                          <Label
                            title={"Meeting Date & Time"}
                            required
                            htmlFor={"meeting-date-time"}
                          />
                          <CustomDateTimePicker
                            value={inputValue.dateTime}
                            onChange={(val) =>
                              handleDateChange(val, "dateTime")
                            }
                            error={inputError.dateTime}
                            helperText={
                              inputError.dateTime &&
                              "Meeting date & time is required"
                            }
                            sx={useStyle}
                          />
                        </Grid>
                      </>
                    );
                  }
                  return null;
                })()}
                {/* <Grid item xs={12}>
                  <Label
                    title={"Current Provider"}
                    required
                    htmlFor={"current-provider"}
                  />
                  <TextInput
                    id={"current-provider"}
                    type={"text"}
                    required
                    error={inputError.currentProvider}
                    helperText={
                      inputError.currentProvider &&
                      "Current provider is required"
                    }
                    defaultStyle={true}
                    placeholder={"Enter current provider"}
                    value={inputValue.currentProvider}
                    name={"currentProvider"}
                    onChange={handleChangeValue}
                  />
                </Grid> */}
                <Grid item xs={12}>
                  <Label
                    title={"Current Provider"}
                    htmlFor={"current-provider"}
                  />
                  <CustomDropDown
                    id={"current-provider"}
                    required
                    value={inputValue.currentProvider}
                    name={"currentProvider"}
                    onChange={handleChangeValue}
                    stylePropos={useStyle}
                    inputError={inputError.currentProvider}
                    helperText={
                      inputError.currentProvider &&
                      "Current provider is required"
                    }
                  >
                    {currentProvider.map((val, ind) => {
                      return (
                        <MenuItem key={ind} value={val}>
                          {val}
                        </MenuItem>
                      );
                    })}
                  </CustomDropDown>
                </Grid>
                <Grid item xs={12}>
                  <Label title={"Note"} required htmlFor={"note"} />
                  <TextInput
                    multiline
                    rows={3}
                    id={"note"}
                    type={"text"}
                    required
                    error={inputError.note}
                    helperText={inputError.note && "Note is required"}
                    defaultStyle={false}
                    style={{
                      "&.MuiFormControl-root .MuiOutlinedInput-root": {
                        padding: "0px",
                      },
                      ...useStyle,
                    }}
                    placeholder={"Enter note"}
                    value={inputValue.note}
                    name={"note"}
                    onChange={handleChangeValue}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    gap={1}
                  >
                    <GlobalButton
                      title={"Add Images"}
                      onClick={() => imageInputRef.current.click()}
                      style={{
                        height: 40,
                      }}
                    />

                    <GlobalButton
                      title={"Upload Pdf"}
                      onClick={() => pdfInputRef.current.click()}
                      style={{
                        height: 40,
                      }}
                    />

                    <input
                      ref={imageInputRef}
                      type="file"
                      accept="image/*"
                      capture="environment"
                      style={{ display: "none" }}
                      onChange={handleUploadImages}
                    />

                    <input
                      ref={pdfInputRef}
                      type="file"
                      accept="application/pdf"
                      style={{ display: "none" }}
                      onChange={handleUploadPdf}
                    />
                  </Stack>

                  {/* UI after upload */}
                  {images?.length > 0 && (
                    <Grid item xs={12}>
                      <Typography
                        variant="body1"
                        fontWeight={"bold"}
                        mt={0.5}
                        mb={1}
                      >
                        Images
                      </Typography>

                      <Stack direction="row" spacing={1} flexWrap="wrap">
                        {images.map((file, index) => (
                          <Box
                            key={index}
                            position="relative"
                            width={80}
                            height={80}
                          >
                            <a
                              href={file}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={file}
                                alt={`images-${index}`}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  borderRadius: 6,
                                  border: "1px solid #ccc",
                                  cursor: "pointer",
                                }}
                              />
                            </a>

                            <IconButton
                              size="small"
                              onClick={() => handleRemoveImage(index)}
                              sx={{
                                position: "absolute",
                                top: -8,
                                right: -8,
                                backgroundColor: "white",
                                border: "1px solid #ccc",
                                padding: 0.3,
                                "&:hover": {
                                  backgroundColor: "#f8d7da",
                                },
                              }}
                            >
                              <CancelOutlinedIcon
                                sx={{ fontSize: 16, color: "red" }}
                              />
                            </IconButton>
                          </Box>
                        ))}
                      </Stack>
                    </Grid>
                  )}
                  {attachment && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        p: 2,
                        mt: 2,
                        border: "1px solid #ccc",
                        borderRadius: "10px",
                        backgroundColor: "#f5f5f5",
                        maxWidth: 500,
                      }}
                    >
                      <PictureAsPdfIcon
                        sx={{ fontSize: 40, color: "#d32f2f" }}
                      />

                      <Box sx={{ flexGrow: 1 }}>
                        <Typography variant="subtitle1" fontWeight="bold">
                          PDF file attached
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ wordBreak: "break-all" }}
                        >
                          {attachment.split("/").pop()}
                        </Typography>
                      </Box>

                      <IconButton
                        component="a"
                        href={attachment}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="View PDF"
                      >
                        <VisibilityIcon />
                      </IconButton>

                      <IconButton
                        onClick={() => setAttachment(null)}
                        aria-label="Remove PDF"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Stack
                    direction={"row"}
                    spacing={1}
                    alignItems={"center"}
                    mb={2}
                  >
                    {/* Check number  */}
                    <CustomCheckBox
                      isChecked={enableThirdParty}
                      handleChecked={() => setEnableThirdParty((pre) => !pre)}
                    />
                    <Typography
                      variant="h6"
                      fontWeight={500}
                      color={"text.davyGrey"}
                    >
                      Send this information to third party
                    </Typography>
                  </Stack>

                  {enableThirdParty && (
                    <Box mt={1}>
                      <Label
                        title={"Receiver Email"}
                        required
                        htmlFor={"receiver-email"}
                      />
                      <TextInput
                        id={"receiver-email"}
                        type={"email"}
                        required
                        error={
                          inputError.receiverEmail ||
                          inputError.isValidReceiverEmail
                        }
                        helperText={
                          inputError.receiverEmail
                            ? "Email is required"
                            : inputError.isValidReceiverEmail
                              ? "Invalid email format"
                              : null
                        }
                        defaultStyle={true}
                        placeholder={"Enter receiver email"}
                        value={inputValue.receiverEmail}
                        name={"receiverEmail"}
                        onChange={handleChangeValue}
                      />
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <GlobalButton
              variant={"custom_gradient"}
              handleClickBtn={handleClose}
              title={"Cancel"}
              style={{
                width: 100,
                background: "red !important",
              }}
            />
            <GlobalButton
              variant={"custom_gradient"}
              handleClickBtn={handleAddLeadProposal}
              title={"Submit"}
              style={{
                width: 100,
              }}
            />
          </DialogActions>
        </BootstrapDialog>
      </LocalizationProvider>
    </>
  );
});

export default AddEditLeadProposalDialog;
